<!--
 * @Author: xuesong
 * @Date: 2021-04-19 10:51:27
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-09-18 11:50:59
 * @Description: 
-->
<template>
    <div class="image-im">
        <div class="info-content">
            <!-- <template v-if="data.imageInfoArray[0].URL">
                <img :src="data.imageInfoArray[0].URL" alt=""
                @click="enlargePicture(data)"/>
            </template>
            <template v-if="data.imageInfoArray[0].imageUrl">
                <img :src="data.imageInfoArray[0].imageUrl" alt=""
                @click="enlargePicture(data)"/>
            </template> -->
            <template v-if="data.localBody">
                <img :src="`${imgOss}${data.localBody}`" alt=""
                @click="enlargePicture(data)"/>
            </template>
            
            
          </div>
    </div>
</template>

<script>
export default {
 props: {
    data: {
      type: Object,
      default: () => {},
    },
    msgId: {
      type: String
    },
    imgName: {
      type: String
    }
  },
  data() {
    return {
      imgOss:process.env.VUE_APP_OSS_URL,//图片公用拼接地址
    }
  },
  created() {
  },
  methods:{
      enlargePicture(e){
          this.$emit('enlargePicture',e,this.msgId,this.imgName)
      }
  }
}
</script>

<style lang="less" scoped>
.image-im{
    border-radius: 4px;    
    .info-content{
        img{
            height: 200px;
            width: 200px;
    border-radius: 4px;    

            
        }
    }
}
</style>